import React from "react";
import { WarningCircle, Eye } from "@phosphor-icons/react";
import { ASSETS } from "@/lib/assets";
import { fmtClock, fmtDate, timeAgo, useNow } from "./ccUtils";

function LiveBadge({ stale, refresh }) {
  if (stale) {
    return (
      <span data-testid="cc-live-status" data-state="stale" className="inline-flex items-center gap-1.5 text-xs text-amber-400 border border-amber-500/40 bg-amber-500/10 rounded-full px-3 py-1">
        <WarningCircle size={14} weight="fill" /> Reconnecting… showing last figures
      </span>
    );
  }
  return (
    <span data-testid="cc-live-status" data-state="live" className="inline-flex items-center gap-2 text-xs text-neutral-300 border border-[#73bf44]/30 bg-[#73bf44]/[0.07] rounded-full px-3 py-1">
      <span className="w-2 h-2 rounded-full bg-[#73bf44] pulse-dot" /> Live · refreshes every {refresh}s
    </span>
  );
}

export function CcHeader({ data, stale, mode, actions }) {
  const now = useNow(1000);
  return (
    <header data-testid="command-centre-header" className="h-14 shrink-0 flex items-center gap-5 px-1">
      <img src={ASSETS.logo} alt="On The Move" className="h-8 w-auto object-contain" />
      <div className="h-9 w-px bg-neutral-800" />
      <div>
        <h1 className="font-heading text-[26px] font-bold tracking-tight text-white leading-none">Command Centre</h1>
        <p className="text-[11px] text-neutral-500 mt-1.5 tracking-wide">OTM Tech AI · Warranty Intelligence · Brisbane time</p>
      </div>
      {mode === "display" && (
        <span data-testid="cc-view-only" className="inline-flex items-center gap-1.5 text-[11px] text-neutral-400 border border-neutral-800 rounded-full px-2.5 py-1">
          <Eye size={13} /> View only
        </span>
      )}
      <div className="ml-auto flex items-center gap-5">
        <LiveBadge stale={stale} refresh={data?.refresh_s || 30} />
        <span data-testid="cc-updated-at" className="text-[11px] font-mono text-neutral-500">Updated {timeAgo(data?.generated_at, now)}</span>
        <div className="text-right" data-testid="cc-clock">
          <div className="font-mono text-[26px] font-semibold text-white leading-none tabular-nums">{fmtClock(now)}</div>
          <div className="text-[11px] text-neutral-500 mt-1">{fmtDate(now)}</div>
        </div>
        {actions}
      </div>
    </header>
  );
}
